import React from 'react'
import HeroImg from 'assets/image/retail-landing-page/hero.png'
import GooglePlayBtn from './GooglePlayBtn'

const Hero = () => {
  return (
    <div
      style={{
        background: `url('${HeroImg}') no-repeat center`,
        backgroundSize: 'cover'
      }}
    >
      <section className="m-auto left-0 right-0 max-w-[1440px]">
        <div
          className={`
          pt-14 pb-16 px-6
          lg:pt-[120px] lg:pb-[98px] lg:px-14  
          xl:pb-[120px] xl:px-[120px]
          md:pt-[96px] md:pb-[120px] `}
        >
          <h1 className="title whitespace-pre-line font-bold text-[32px] lg:text-5xl xl:text-[56px] leading-[150%] lg:leading-[150%] xl:leading-[120%] text-white relative max-w-[756px]">
            Solusi beli barang kulakan dengan harga terbaik untuk toko kemasan,
            garmen dan elektrikal dari manufaktur lokal
          </h1>
          <p className="mt-6 xl:mt-6 leading-[150%] max-w-[720px] text-white">
            Manuva Retail adalah aplikasi untuk pedagang grosir dan semi grosir
            untuk membeli barang kulakan dari manufaktur lokal untuk produk
            kemasan, garmen, dan elektrikal
          </p>

          <GooglePlayBtn />
        </div>
      </section>
    </div>
  )
}

export default Hero
